import React from "react";
import { Input, Row, Typography, Form, Col } from "antd";
import appLabel from "../../../../../config/appLabel";
import { labelConfig } from "../../../glAndAccounting.config";
const { Text } = Typography;

const GLOverview = (props) => {
  const { onFinish, form, formData, glDetail } = props;
  const displayValue = (value) =>
    value !== undefined && value !== null && value !== "" ? value : "-";
  const displayDate = (value) => {
    if (!value) return "-";
    if (Array.isArray(value)) {
      return value.join("-");
    }
    return displayValue(value);
  };
  const displayStatus = (disabled) => {
    if (disabled === true) return "Disabled";
    if (disabled === false) return "Active";
    return "-";
  };
  return (
    <Form layout="vertical" onFinish={onFinish} form={form} initialValues={formData}>
      <Row>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>{appLabel.GLCode}</Text>}>
            <Input
              className="of-bold-disable-input"
              disabled
              value={displayValue(glDetail?.glCode)}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>{labelConfig.glName}</Text>}>
            <Input
              className="of-bold-disable-input"
              disabled
              value={displayValue(glDetail?.name)}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>{appLabel.shortName}</Text>}>
            <Input
              className="of-bold-disable-input"
              disabled
              value={displayValue(glDetail?.shortName || glDetail?.name)}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>{appLabel.category}</Text>}>
            <Input
              className="of-bold-disable-input"
              disabled
              value={displayValue(glDetail?.type?.value || glDetail?.category)}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>{labelConfig.accountLevel}</Text>}>
            <Input
              className="of-bold-disable-input"
              disabled
              value={displayValue(glDetail?.usage?.value || glDetail?.accountLevel)}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>{appLabel.parent}</Text>}>
            <Input
              className="of-bold-disable-input"
              disabled
              value={displayValue(glDetail?.parentName || glDetail?.parentId)}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>{labelConfig.accountStatus}</Text>}>
            <Input
              className="of-bold-disable-input"
              disabled
              value={displayStatus(glDetail?.disabled)}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>{labelConfig.naturalBalance}</Text>}>
            <Input
              className="of-bold-disable-input"
              disabled
              value={displayValue(glDetail?.naturalBalance?.value || glDetail?.naturalBalance)}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>{labelConfig.regulatoryReportingCode}</Text>}>
            <Input
              className="of-bold-disable-input"
              disabled
              value={displayValue(glDetail?.regulatoryReportingCode || glDetail?.glCode)}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>{labelConfig.ifrsClassification}</Text>}>
            <Input
              className="of-bold-disable-input"
              disabled
              value={displayValue(
                glDetail?.ifrsClassification?.value || glDetail?.ifrsClassification,
              )}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>{labelConfig.taxCategory}</Text>}>
            <Input
              className="of-bold-disable-input"
              disabled
              value={displayValue(glDetail?.taxCategory?.value || glDetail?.taxCategory)}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>{labelConfig.openingDate}</Text>}>
            <Input
              className="of-bold-disable-input"
              disabled
              value={displayDate(glDetail?.openingDate || glDetail?.approvedOnDate)}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>{labelConfig.closingDate}</Text>}>
            <Input
              className="of-bold-disable-input"
              disabled
              value={displayDate(glDetail?.closingDate || glDetail?.approvedOnDate)}
            />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default GLOverview;
